// extracted by mini-css-extract-plugin
export default {"todo":"contentTextStratus_todo__voB8r","inProgress":"contentTextStratus_inProgress__38l5K","done":"contentTextStratus_done__r0wNW"};